import { render, staticRenderFns } from "./cursor.vue?vue&type=template&id=15c12438&scoped=true&"
import script from "./cursor.vue?vue&type=script&lang=js&"
export * from "./cursor.vue?vue&type=script&lang=js&"
import style0 from "./cursor.vue?vue&type=style&index=0&id=15c12438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c12438",
  null
  
)

export default component.exports